import styled from "@emotion/styled"

export const CMLabel = styled('label')({
    fontSize: '14px',
    marginBottom: '4px',
    fontWeight: '500',
    lineHeight: 1.5,
    color: '#505d69',
    display: 'flex',
    alignItems: 'center'
})
